import { NgTemplateOutlet } from '@angular/common';
import { Component, contentChild, Directive, input, TemplateRef, ViewEncapsulation } from '@angular/core';

import { TranslatePipe, TranslationTokens } from '@ideals/components/translate';

import { IllustrationComponent, IllustrationName } from '../../illustration';
import { SanitizePipe } from '../../sanitize';

export type PagePlaceholderImage = IllustrationName;

@Directive({
  selector: 'ng-template[idealsPagePlaceholderMessage]',
})
export class PagePlaceholderMessageDirective {}

@Directive({
  selector: 'ng-template[idealsPagePlaceholderTitle]',
})
export class PagePlaceholderTitleDirective {}

@Component({
  encapsulation: ViewEncapsulation.None,
  host: {
    '[attr.title]': 'null',
    '[class.ideals-page-placeholder--large]': 'size() === "large"',
    '[class.ideals-page-placeholder--medium]': 'size() === "medium"',
    '[class.ideals-page-placeholder--small]': 'size() === "small"',
    class: 'ideals-page-placeholder m-auto',
    fxLayout: 'column',
    fxLayoutAlign: 'center center',
  },
  imports: [
    IllustrationComponent,
    NgTemplateOutlet,
    SanitizePipe,
    TranslatePipe,
  ],
  selector: 'ideals-page-placeholder',
  styleUrl: './page-placeholder.component.scss',
  templateUrl: './page-placeholder.component.html',
})
export class PagePlaceholderComponent {
  readonly image = input<PagePlaceholderImage>();
  readonly imageSize = input<'large' | 'small'>('large');
  readonly message = input<TranslationTokens>();
  readonly size = input<'large' | 'medium' | 'small'>('large');
  readonly title = input<TranslationTokens>();

  protected readonly messageTemplateRef = contentChild(PagePlaceholderMessageDirective, { read: TemplateRef });
  protected readonly titleTemplateRef = contentChild(PagePlaceholderTitleDirective, { read: TemplateRef });
}
